import { Table } from "@mantine/core";
import { useCallback } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { DateTimeDisp } from "src/components/shared/DateTime";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi } from "src/hooks";
import { type ILink } from "src/interfaces";
import { PageContainer, StyledTd, StyledTh, StyledTr } from "src/styled";

import { LayoutContainer } from "../../YachtSetup/VesselParticulars/YachtSetupHistory/YachtSetupHistory.styled";

interface ISignersHistoryItem {
  id: string;
  full_name: string;
  rolename: string;
  dateLT: string;
  dateUTC: string;
  action?: string;
  detail?: string;
}

const mapHistoryItems = (res: any): ISignersHistoryItem[] =>
  res?.data?.list ?? res?.data?.signers ?? res?.list ?? [];

const LogbookSignersHistory = () => {
  const { data, isLoading } = useGetApi({
    request: "get-signers-hist",
    mapper: mapHistoryItems,
  });

  const getLinks = useCallback((links: ILink[]) => {
    const advancedIndex = links.findIndex(
      link => link.href === "/settings/advanced",
    );
    const prefix =
      advancedIndex >= 0
        ? links.slice(0, advancedIndex + 1)
        : links.slice(0, -2);

    return [
      ...prefix,
      {
        title: "Logbook Signers",
        href: "/settings/advanced/signers",
      },
      {
        title: "History",
        href: "/settings/advanced/history/signers",
      },
    ];
  }, []);

  const renderUser = useCallback((role: string, name: string) => {
    let text = "";
    if (role) text += role;
    if (name) text += ` ${name}`;
    return text;
  }, []);

  return (
    <PageContainer>
      <Breadcrumbs customLinks={getLinks} />
      <LayoutContainer>
        <Table>
          <thead>
            <StyledTr>
              <StyledTh>Edit description</StyledTh>
              <StyledTh>Edited by</StyledTh>
              <StyledTh>Edit date</StyledTh>
            </StyledTr>
          </thead>
          <tbody>
            {data &&
              !isLoading &&
              data.map(row => (
                <StyledTr key={row.id}>
                  <StyledTd>
                    {[row.action ?? "Logbook Signers Details Updated", row.detail]
                      .filter(Boolean)
                      .join(" ")}
                  </StyledTd>
                  <StyledTd>{renderUser(row.rolename, row.full_name)}</StyledTd>
                  <StyledTd>
                    <DateTimeDisp
                      lt={row.dateLT}
                      utc={row.dateUTC}
                      dir="row"
                      color="text"
                    />
                  </StyledTd>
                </StyledTr>
              ))}
          </tbody>
        </Table>
      </LayoutContainer>
      {!(data ?? isLoading) && <Loader />}
    </PageContainer>
  );
};

export default LogbookSignersHistory;
